// extracted by mini-css-extract-plugin
module.exports = {"purchaseComplete":"VerifiedEmail_purchaseComplete__2AAm6","stars":"VerifiedEmail_stars__2ygp7","returnToVideo":"VerifiedEmail_returnToVideo__3KA6V"};